export function renderEntity(product, trans, onChange) {
  let containerEntityEl = document.createElement("div");

  if (!product?.settings?.entitiesAvailable || product?.settings?.entitiesAvailable?.length === 0) return containerEntityEl;

  let entitiesAvailable = [];
  if (product?.settings?.entitiesAvailable?.length > 0 && product?.entity_selection) {
    const availableEntities = product?.settings?.entitiesAvailable?.filter((entity) => entity.status === "for-rent" && String(entity.is_active) === "1");
    entitiesAvailable = availableEntities;
  }

  containerEntityEl.style.marginTop = "20px";
  containerEntityEl.style.marginBottom = "20px";

  let createSelectEntityLabel = document.createElement("label");
  createSelectEntityLabel.setAttribute("for", "entity");
  createSelectEntityLabel.textContent = trans("website.product-select-entity");

  let createSelectEntity = document.createElement("select");
  createSelectEntity.onchange = (e) => onChange(e);
  createSelectEntity.className = "form-control";
  createSelectEntity.id = "entity";
  createSelectEntity.name = "entity";
  createSelectEntity["style"].width = "100%";

  let selectHolder = document.createElement("option");
  selectHolder.value = "";
  selectHolder.textContent = trans("common.select");
  selectHolder.disabled = true;
  selectHolder.selected = true;
  createSelectEntity.appendChild(selectHolder);

  entitiesAvailable?.forEach((ent) => {
    let option = document.createElement("option");
    option.value = ent?.token;
    option.textContent = ent?.name;
    createSelectEntity.appendChild(option);
  });

  containerEntityEl.appendChild(createSelectEntityLabel);
  containerEntityEl.appendChild(createSelectEntity);

  return containerEntityEl;
}
